import styled from 'styled-components'
import { DrawerBodyContentWrapper } from '../drawerBodyLayout.styles'
import { HOTEL_DRAWER_CONTENT_CONTAINER_NAME } from './constants'

export const ContentWrapper = styled(DrawerBodyContentWrapper)`
  container: ${HOTEL_DRAWER_CONTENT_CONTAINER_NAME} / inline-size;
`
